import {addNamespace} from '#/notes/store/helpers'

export const mutationTypes = {
  /**
   * sets the authors array into the state
   * @param {Array} authors array of author objects
   */
  SET_AUTHORS: 'setAuthors'
}

export default addNamespace('notes/authors', mutationTypes)
